import PATH_CONFIG from "./path-config";
import requestAPI from "./request";

export default class ProductService {


    static getProductsByCriteria(params) {

        if(params.q === ""){
            delete params.q;
        }

        if(params.isActive === null){
            delete params.isActive;
        }

        const options = {
            method: "GET",
            params
        };

        return requestAPI(PATH_CONFIG.PRODUCTS, options)
            .then(response => {

                let numPages = Math.ceil(
                    response.data.count / params.itemsPerPage
                );
                return {
                    products: response.data.products,
                    total_products: response.data.count,
                    total_pages: numPages,
                };
            });
    }
    static productList;

    static getAllProducts() {
        if (this.productList) return this.productList;
        const requestPath = `${PATH_CONFIG.PRODUCTS}`;
        const options = {
            method: "GET"
        };

        return requestAPI(requestPath, options)
            .then(response => {
                this.productList = response;
                return response;
            });
    }

    static updateProduct(productId, newStatus) {
        this.productList = undefined;
        const requestPath = `${PATH_CONFIG.PRODUCTS}/${productId}`;
        const options = {
            method: "PATCH",
            data: newStatus
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }

    static getProductById(productId) {
        const requestPath = `${PATH_CONFIG.PRODUCTS}/${productId}`;
        const options = {
            method: "GET"
        };

        return requestAPI(requestPath, options)
            .then(response => {
                return response;
            });
    }

    static createProduct(product) {
        this.productList = undefined;
        const options = {
            method: "POST",
            data: product
        };

        return requestAPI(PATH_CONFIG.PRODUCTS, options)
            .then(response => {
                return response;
            });
    }
}



// WEBPACK FOOTER //
// ./src/services/product-service.js